// extracted by mini-css-extract-plugin
module.exports = {"section":"Information_section__h2TNX","title":"Information_title__WGzdB","desc":"Information_desc__rjW4o","button":"Information_button__WJNxl"};